import { Component, OnInit, Input, Output, EventEmitter,OnChanges, SimpleChanges } from '@angular/core';
import { ENTITY_TYPES, OrderService } from 'src/app/order-service.service';
import { Table, Pagination, TableDataTypes, TableData } from 'src/app/shared/types';
import { FilterService, DateFilterInput, TextFilterInput, SearchableDropDownFilterInput,
  RangeSliderInput, SingleSearchableDropdown, QuickFilters} from 'src/app/filter.service';
import { HelperService } from 'src/app/helper.service';
import { EntityService } from 'src/app/entity.service';
import { DataService } from '../../data.service';
import { Router } from '@angular/router';
import { HostOrderDetailsService } from './host-order-details.service';
import { FraudService } from '../../fraud-component/fraud-view.service';


const currentDate = new Date();
const startDate = new Date();
startDate.setDate(startDate.getDate() - 1);
HelperService.resetTimeTo(currentDate);
HelperService.resetTimeTo(startDate);
export const DEFAULT_DATE = {
  FROM_DATE: new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() - 31)),
  ONE_DAY_FROM_DATE: new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() - 1)),
  CURRENT_FROM_DATE: new Date(new Date(currentDate).setDate(new Date(currentDate).getDate())),
  EARNINGS_FROM_DATE: new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() - 7)),
  TO_DATE: currentDate
};
function defaultFiters() {
  let startDuration = HelperService.getDateOnlyV1(new Date(new Date(currentDate).setDate(new Date(currentDate).getDate() - 31)));
  let endDuration = HelperService.getDateOnlyV1(currentDate);
  return {
    startDuration,
    endDuration,
    cities: '',
    services: '',
    orderId: '',
    rating: '',
    status: 'all',
  };
}
@Component({
  selector: 'app-host-order-details',
  templateUrl: './host-order-details.component.html'
})
export class HostOrderDetailsComponent implements OnInit, OnChanges {
  @Input() captainMobile: string;
  @Input() captainId: string;
  @Input() hostDetailsToggleableHeaders: string[];
  @Output() toggleHeaders: EventEmitter<any> = new EventEmitter();
  currentNumber: any;
  orders: any[];
  orderTable: Table;
  fromDate = DEFAULT_DATE.FROM_DATE;
  toDate = DEFAULT_DATE.TO_DATE;
  filtersApplied = defaultFiters();
  cities: any = [];
  services: any = [];
  filterCount = 0;
  orderIds = [] ;
  minDate: string;
  maxDate: string; 
  statusList: any = [
    'all',
    'onTheWay',
    'arrived',
    'started',
    'dropped',
    'aborted',
    'customerCancelled'
  ];
  rating = {from : '0', to : '5'};
  fraudOrdersList: any;

  constructor(
    public orderService: OrderService,
    public filterService: FilterService,
    public entityService: EntityService,
    private dataService: DataService,
    private router: Router,
    private hostOrderDetailsService: HostOrderDetailsService,
    private fraudService: FraudService
  ) { }

  ngOnInit() {
    this.entityService.getCities().subscribe(cities => {
      this.cities.push(...cities);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes && changes.captainId && changes.captainId.currentValue) {
      this.defineOrderTable(this.captainId);
    }
  }

  private assignAppliedFilters(newFilter = {}) {
    Object.keys(this.filtersApplied).forEach(key => {
      delete this.filtersApplied[key];
    });
    Object.assign(this.filtersApplied, newFilter);
  }

  private declareTable(pageNumber = 0) {
    this.dataService.searchUserCount.subscribe(result => {
      if (!this.currentNumber || (this.currentNumber === result)) {
        this.filterService.appliedFilters = this.filtersApplied;
      } else {
        this.filterService.appliedFilters = {};
        this.filtersApplied = defaultFiters();
      }
      this.currentNumber = result;
    });
    this.orderTable = new Table({
      tableHeader: {
        toString: () => {
          if (this.fromDate.getTime() === DEFAULT_DATE.FROM_DATE.getTime() &&
          this.toDate.getTime() === DEFAULT_DATE.TO_DATE.getTime()
          ) {
            return `Order Details`;
          }
          return `Order Details:- ${HelperService.dateString(this.fromDate)} - ${HelperService.dateString(this.toDate)}`;
        }
      },
      headers: {
        dateTime: 'Trip Date \n Start Time',
        orderIdCity: 'OrderId \n City',
        service: 'Service',
        pickupDrop: 'Pickup \n Drop',
        customer: 'Customer',
        earnings: 'Earnings',
        adjustments: 'Adjustments',
        coins: 'Coins',
        tripDate: 'Requested Date \n Time',
        initiatedBy: 'Initiated By',
        status: 'Status',
        paymentStatus: 'Payment Status',
        overlap: 'Overlap',
        ratings: 'Ratings',
      },
      selectedHeader: 0,
      toggleableHeaders: this.hostDetailsToggleableHeaders,
      pagination: new Pagination(pageNumber, 10),
      config: {
        refresh: true,
      },
      onRefresh: () => {
        this.orderTable = null;
        this.defineOrderTable(this.captainId, this.fromDate, this.toDate);
      },
      appliedFilters: this.filtersApplied,
      filterComponents: [
        new QuickFilters({
          key: 'duration',
          default: '',
          title: 'Duration',
        }),
        new SearchableDropDownFilterInput({
          key : 'cities',
          title: 'Cities',
          values: this.cities,
        }),
        new SingleSearchableDropdown({
          key : 'status',
          title: 'Status',
          values: this.statusList,
        }),
      ],
      onFilter: () => {
        const timeSlot = this.filterService.appliedFilters.duration || ['', ''];
        let duration = [];
        if (!Array.isArray(timeSlot)) {
          duration.push(timeSlot['start']);
          duration.push(timeSlot['end']);
        } else {
          duration = timeSlot;
        }
        let startDuration = duration[0];
        let endDuration = duration[1];
        const cities = this.filterService.appliedFilters.cities;
        const status = this.filterService.appliedFilters.status;
        const filtersApplied = {
          duration: {
            start: startDuration,
            end: endDuration,
          },
          startDuration,
          endDuration,
          cities,
          status,
        };
        Object.assign(this.filtersApplied, filtersApplied);
        const isValidNumber = (value) => {
          return ((parseInt(value, 10) === 0) || value);
        };
        if ((startDuration && endDuration)  || cities) {
          startDuration = HelperService.isValidDate(new Date(startDuration)) ? new Date(startDuration) : undefined;
          endDuration = HelperService.isValidDate(new Date(endDuration)) ? new Date(endDuration) : undefined;
          return this.defineOrderTable(this.captainId, startDuration, endDuration, this.filtersApplied);
        }
        return this.defineOrderTable(this.captainId, undefined, undefined, this.filtersApplied);
      },
      data: []
    });
  }

  onPaginationChange(event) {
    this.orderTable.data = [];
    this.fillDataToTable(DEFAULT_DATE.FROM_DATE, DEFAULT_DATE.TO_DATE, this.filtersApplied);
  }

  changeInHeader(header) {
    this.toggleHeaders.emit(header);
  }

  getOrderList(captainId: string, fromDate?: Date, toDate?: Date, filters?: any) {
    this.filterCount = 0;
    const dateFilter = [];
    const filterKeys = Object.keys(this.filtersApplied);
    const ignoreKeys = ['startDuration', 'endDuration'];
    if (this.filtersApplied && this.filtersApplied['duration']) {
      if (this.filtersApplied['duration'].start) {
        dateFilter.push(this.filtersApplied['duration'].start);
      }
      if (this.filtersApplied['duration'].end) {
        dateFilter.push(this.filtersApplied['duration'].end);
      }
    }
    if (dateFilter.length > 0) {
      this.filterCount++;
    }
    for (let i = 0; i < filterKeys.length ; i++) {
      if (Array.isArray(this.filtersApplied[filterKeys[i]]) && (this.filtersApplied[filterKeys[i]]).length > 0) {
        this.filterCount++;
      } else if (typeof(this.filtersApplied[filterKeys[i]]) === 'object') {
        if (filterKeys[i] && filterKeys[i] === 'ratingInput' &&
        ((this.filtersApplied[filterKeys[i]]['from']) || (this.filtersApplied[filterKeys[i]]['to']))) {
          this.filterCount++;
        }
      } else {
        if (this.filtersApplied[filterKeys[i]] && ignoreKeys.indexOf(filterKeys[i]) === -1 &&
            (this.filtersApplied[filterKeys[i]]).length > 0) {
          this.filterCount++;
        }
      }
    }
    console.log("get ordersFor cpatain captainId", this.captainId);
    return this.orderService.getOrdersForCaptain(this.captainId, this.orderTable.pagination, fromDate, toDate, ENTITY_TYPES.CAPTAIN, filters);
  }

  isEmpty(value) {
    return (value == null || value.length === 0);
  }

  fillDataToTable(fromDate?: Date, toDate?: Date, filters?: any) {
    this.orderTable.dataWillLoad();
    this.getOrderList(this.captainId, fromDate, toDate, filters).subscribe(async({orders, count}) => {
      // this.declareTable();
      const self = this;
      function createTableData(value, className?, hoverData?, flag = false, suspendFlag = false) {
        return new TableData({
          data: value,
          hoverData: hoverData ? hoverData : null,
          type: TableDataTypes.DATA,
          className: className ? className + ' cursor-pointer' : 'cursor-pointer whiteSpacePre',
          suspendFlag: suspendFlag,
          flag,
          onClick: (data) => {
            const newRelativeUrl = self.router.createUrlTree([`/order/${data._id.data}`]);
            const baseUrl = window.location.href.replace(self.router.url, '');
            window.open(baseUrl + newRelativeUrl, '_blank');
          }
        });
      }
      let orderIdToAdjustmentsMap = {};
      var orderIds = [] ;
      this.minDate = '' , this.maxDate = '';
        orders.map(order =>{
         orderIds.push(order._id);
         var currentDate= order.date.toISOString();
         this.minDate = this.minDate && (this.minDate < currentDate) ? this.minDate : currentDate ;
         this.maxDate = this.maxDate && (this.maxDate > currentDate) ? this.maxDate : currentDate ;
      });

      

      
      if(this.minDate){
        this.minDate = this.minDate.substring(0,10);
      }
      if(this.maxDate){
        const FifteenDaysPostMaxDate = new Date(this.maxDate);
        FifteenDaysPostMaxDate.setDate(FifteenDaysPostMaxDate.getDate() + parseInt("15"));
        this.maxDate = FifteenDaysPostMaxDate.toISOString().substring(0,10);
      }
      this.orderIds = orderIds ;
            
      this.fraudOrdersList = await this.fraudService.checkFraudOrders({ orders: orderIds }).toPromise();

      const tripStartTimeMap = await HelperService.fetchTripStartTimeMap(
        orders,
        'hostTripId',
        (ids, date) => this.hostOrderDetailsService.getTripsBulk(ids, date).toPromise()
      );

      const overlapScoreMap = await HelperService.fetchOverlapScoreMap(
        orders,
        (orderIds) => this.hostOrderDetailsService.getPoolTripsBulk(orderIds).toPromise()
      );

      // Client-side sort by tripDate + startTime (desc) — cross-page order follows server sort.
      const sortedOrders = HelperService.sortByTripDateAndStartTime(orders, tripStartTimeMap, 'hostTripId');

      this.orders = sortedOrders.map(order => {
        const orderId = order._id;
        const orderDate = new Date(order.date);
        const self = this;
        const flag = this.fraudOrdersList.orders[orderId] ? true : false;

        let earningsDisplay = '-';
        if (order.hostEarnings !== null && order.hostEarnings !== undefined) {
          earningsDisplay = '₹' + parseFloat(order.hostEarnings).toFixed(2);
        }

        const { initiatedByDisplay } = HelperService.formatPoolDataDisplay(order.poolData);
        const hostTripId = order.poolData && order.poolData.hostTripId;
        const tripDateRaw = (order.poolData && order.poolData.tripDate) || '';
        const startTime = HelperService.getTripStartTime(tripStartTimeMap, hostTripId, tripDateRaw);
        const { tripDateDisplay, startTimeDisplay } = HelperService.formatTripDateTimeDisplay(tripDateRaw, startTime);
        const dateTimeDisplay = tripDateRaw ? (tripDateDisplay + '\n' + startTimeDisplay) : 'NA';
        const overlapDisplay = order.status === 'dropped'
          ? HelperService.formatOverlapDisplay(overlapScoreMap[String(order._id)])
          : '-';

        return {
          _id: createTableData(orderId),
          dateTime: createTableData(dateTimeDisplay, null, null, flag),
          orderIdCity: new TableData({
            data: order.orderId + '\n' + order.city,
            type: TableDataTypes.DATA,
            className: 'cursor-pointer whiteSpacePre',
            onClick: (data) => {
              const newRelativeUrl = self.router.createUrlTree([`/order/${data._id.data}`]);
              const baseUrl = window.location.href.replace(self.router.url, '');
              window.open(baseUrl + newRelativeUrl, '_blank');
            }
          }),
          service: createTableData(order.service),
          pickupDrop: createTableData(order.pickup + '\n' + order.drop),
          customer: createTableData(order.customer),
          earnings: createTableData(earningsDisplay),
          adjustments: createTableData(orderIdToAdjustmentsMap[orderId] && orderIdToAdjustmentsMap[orderId].adjustments),
          coins: createTableData(orderIdToAdjustmentsMap[orderId] && orderIdToAdjustmentsMap[orderId].coins),
          tripDate: createTableData(HelperService.dateString(orderDate) + '\n' + order.orderTime),
          initiatedBy: createTableData(initiatedByDisplay),
          status: createTableData(order.status, null, order.cancelReason || null),
          paymentStatus: createTableData(order.paymentStatus),
          overlap: createTableData(overlapDisplay),
          ratings: createTableData(order.customerRating),
        };
      });

      this.orderTable.data = this.orders;
      this.orderTable.filterCount = this.filterCount;
      this.orderTable.pagination.count = count;
  
    return 

    });
  }

  defineOrderTable(captainId: string, fromDate = DEFAULT_DATE.FROM_DATE, toDate = DEFAULT_DATE.TO_DATE,
    filters = this.filtersApplied) {
      this.declareTable();
      this.fromDate = fromDate;
      this.toDate = toDate;
      this.fillDataToTable(fromDate, toDate, filters);
  }
}
